<template>
<!--  -->
  <div class='carousel'>
    <Carousel v-model="carouselIndex" :loop='carouselImages.length > 1' arrow='never' :autoplay='carouselImages.length > 1' :autoplay-speed='5000'>
        <CarouselItem v-for='item in carouselImages' :key='"car-it-" + item.uuid'>
            <div @click="handlePicture(item.uuid)" class="h-carousel-item cFlex">
              <img class="carousel-img" :src="slideshowIp+'static/file/'+item.remark.diskFileName">
            </div>
        </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
import { getCarousel } from '@/api/homePage.js'

export default {
  name: '',
  props: {

  },
  data () {
    return {
      carouselIndex:0,
      carouselImages:[],
    }
  },
  mixins: [],
  components: {

  },
  computed: {
      ...mapGetters(['slideshowIp']),
  },
  watch: {

  },
  created () {
    getCarousel().then((res) => {
        if (res.status == 200) {
            this.carouselImages = res.data || []
        }
    })
  },
  mounted () {

  },
  methods: {
    /* 图片详情 */
    handlePicture(uuid){
        // this.$router.push({
        //     name:'pictureDetail',
        //     query:{
        //         uuid:uuid
        //     }
        // });
    },
  }
}
</script>

<style lang="less" scoped>
.carousel {
    height: 500px;
    position: relative;
    .carousel-img {
      height: 500px;
      width: 100%;
    }
}
</style>
